export default __webpack_public_path__ + "static/media/sc22.8d0d353d.mp4";